import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'

import {
	BreadCrumb,
	Button,
	Loader,
	MenuQuestions,
	MenuQuestionsMobile,
	Title,
} from '@components/atoms'
import { Question, QuestionPrint } from '@components/molecules'
import { AddCircle20Regular } from '@fluentui/react-icons'
import { useIsMobile, usePrintQuestion } from '@hooks'
import { FilterStateProps } from '@hooks/useQuestion'
import { QuestionType } from '@models/questions.model'
import { notebookAPI } from '@services/NotebookAPI'

import { questionsStyles } from '../../Questions/style'
import { NotebooksStyles } from '../style'

const { container, title, LinkToQuestion } = NotebooksStyles

const {
	ContainerFocus,
	buttonsFocus,
	containerPrint,
	containerButtonNextPage,
} = questionsStyles

export const NotebookErrorShow = () => {
	const [notebookQuestions, setNotebookQuestions] = useState<
		Array<QuestionType>
	>([])
	const [pageFocusMode, setPageFocusMode] = useState(1)
	const [values, setValues] = useState<FilterStateProps>({
		filterSaved: {},
		disciplines: [],
		materId: [],
		subMaterId: [],
		year: [],
		office: [],
		juries: [],
		institutions: [],
		comment: 'value',
		quest: 'all',
		mode: 'value',
		readingMode: { value: 1, label: 'Modo scroll' },
		QuestionsSolve: { value: '50', label: 'Questões a resolver:  50' },
	})
	const [visibleElements, setVisibleElements] = useState(50)

	const showMore = () => {
		setVisibleElements(
			(prevCount) => prevCount + Number(values.QuestionsSolve.value)
		)
	}

	const isMobile = useIsMobile()
	const componentRef = useRef<HTMLDivElement>(null)
	const { handlePrint } = usePrintQuestion({
		componentRef,
		setQuestions: setNotebookQuestions,
		questions: notebookQuestions,
	})

	const { id } = useParams()

	const [getOneNotebookError, { data, isSuccess, isLoading }] =
		notebookAPI.useGetOneNotebookErrorMutation()

	useEffect(() => {
		if (id) {
			getOneNotebookError(id)
		}
	}, [getOneNotebookError, id])

	useEffect(() => {
		if (isSuccess && data) {
			setNotebookQuestions(data.questions)
		}
	}, [isSuccess, data])

	return (
		<div className={container()}>
			<div>
				<BreadCrumb
					buttonReturn
					locations={
						data?.notebook.name
							? [
									{ name: 'Cadernos', link: '/cadernos' },
									{ name: data?.notebook.name, link: '/cadernos' },
									{ name: 'Caderno Questões com erros', link: '' },
							  ]
							: []
					}
				/>
				<div className={title()}>
					<Title variant='h1' color='$neutral160'>
						Questões com erros
					</Title>
				</div>
			</div>

			<LinkToQuestion to='/vade-mecum-de-questoes'>
				Adicionar questões
				<AddCircle20Regular />
			</LinkToQuestion>

			<div>
				{!isMobile && (
					<MenuQuestions
						questions={notebookQuestions}
						setFilter={setValues}
						values={values}
						handlePrint={handlePrint}
					/>
				)}
				{isMobile && (
					<MenuQuestionsMobile
						questions={notebookQuestions}
						setFilter={setValues}
						values={values}
						handlePrint={handlePrint}
					/>
				)}
			</div>

			<div>
				{isLoading && <Loader />}
				{values.readingMode.value === 1 ? (
					<div style={{ marginTop: '40px' }}>
						{notebookQuestions &&
							notebookQuestions.length > 0 &&
							notebookQuestions
								.slice(0, visibleElements)
								.map((value, index) => (
									<Question
										value={value}
										key={index}
										index={index + 1}
										setValue={setNotebookQuestions}
									/>
								))}

						{notebookQuestions && notebookQuestions.length > 0 && (
							<div className={containerButtonNextPage()}>
								<Button
									onClick={showMore}
									disabled={visibleElements >= notebookQuestions.length}
								>
									Carregar mais
								</Button>
							</div>
						)}
					</div>
				) : (
					<div style={{ marginTop: '40px' }}>
						{notebookQuestions.length > 0 &&
							notebookQuestions.map((value, index) => (
								<ContainerFocus key={index} open={pageFocusMode === index + 1}>
									<Question
										value={value}
										index={index + 1}
										setValue={setNotebookQuestions}
									/>
								</ContainerFocus>
							))}

						{notebookQuestions.length > 0 && (
							<div className={buttonsFocus()}>
								<Button
									outlined
									css={{ maxWidth: '159px' }}
									disabled={pageFocusMode <= 1}
									onClick={() => {
										setPageFocusMode((prev) => {
											if (prev > 1) {
												return prev - 1
											}

											return prev
										})
									}}
								>
									Anterior
								</Button>
								<Button
									outlined
									css={{ maxWidth: '159px' }}
									onClick={() => {
										setPageFocusMode((prev) => prev + 1)
									}}
									disabled={pageFocusMode >= notebookQuestions.length}
								>
									Próximo
								</Button>
							</div>
						)}
					</div>
				)}
			</div>

			<div className={containerPrint()}>
				<div ref={componentRef}>
					<img alt='logo' src='/assets/svg/logo.svg' />

					{notebookQuestions &&
						notebookQuestions?.length > 0 &&
						notebookQuestions?.map((value, index) => (
							<QuestionPrint value={value} key={index} index={index + 1} />
						))}
				</div>
			</div>
		</div>
	)
}
